<div class="total-capital-wrapper w-full max-w-sm">
  <div class="flex items-center justify-between mb-1">
    <p class="font-secondary font-medium !m-0 !p-0 text-sm text-white max-w-48 text-ellipsis overflow-hidden" title="{{ capitalName }}">
      {{ capitalName }}</p>
    <p class="!m-0 !p-0 flex gap-2 font-secondary text-sm text-white">
      <span class="font-secondary font-bold text-white text-sm">
        {{ totalPercent === 0 ? '100%' : totalPercent + '%' }}
      </span>
      {{ totalPercent === 0 ? ' allocated' : ' unallocated' }}
    </p>
  </div>
  <div class="progress-container">
    <div class="progress-fill" *ngIf="totalPercent > 0" [style.width.%]="totalPercent"></div>
  </div>
</div>